import * as Yup from 'yup'

import { FC, HTMLAttributes, useEffect } from "react"

import { IEntity } from "../../../../../base/types"
import { IHiddenValueProps } from './IHiddenValueProps'
import { useFormContext } from "../../form"
import { useFormikContext } from "formik"

interface IHiddenFieldProps extends HTMLAttributes<HTMLInputElement>, IHiddenValueProps {
    name: string
}

export const HiddenValueField: FC<IHiddenFieldProps> = ({
    id, name, value
}) => {
    const { getFieldProps, setFieldValue } = useFormikContext<IEntity>() || {}
    const { updateSchema } = useFormContext()

    useEffect(() => {
        let shape = Yup.string()

        const schema = Yup.object().shape({
            [name]: shape
        });

        updateSchema(schema);
        // eslint-disable-next-line
    }, [name, value, updateSchema])

    useEffect(() => {
        const props = getFieldProps(name)
        if (value === props.value)
            return
        setTimeout(() => setFieldValue(name, value || ''))
        // eslint-disable-next-line
    }, [name, value, setFieldValue, getFieldProps])

    let fieldProps = name ? getFieldProps(`['${name}']`) : { value: '' }
    if (fieldProps.value === undefined)
        fieldProps = { ...fieldProps, value: '' }

    return <>
        <input type='hidden' id={id} {...fieldProps} />
    </>
}
